import { effWidth } from '../lib/uiScale';
import MaskToggle from './MaskToggle';
import { useEffect, useState } from 'react';
import { Settings2, X, Smartphone, LayoutGrid } from 'lucide-react';
import { useWalkHide, setWalkHide } from '../lib/walk';
import { getMode } from '../lib/profiles';

// map buttons that have no function in a branch are not offered there
const NO_TAB = { building: ['vis', 'heat', 'filter'], garden: ['vis', 'overlay', 'heat'], outdoor: ['vis', 'overlay', 'heat', 'filter'] };

const KEY = 'giss_map_ui';
export const UI_TABS = ['vis', 'fit', 'gps', 'rtk', 'target', 'coords', 'gnss', 'legend', 'overlay', 'heat', 'layer', '3d', 'sv', 'filter'];
export const UI_COMPACT = ['vis', 'fit', 'gps', 'rtk', 'overlay', '3d', 'filter'];
const load = () => {
  try { let v = JSON.parse(localStorage.getItem(KEY)); if (v?.tabs) { if (!v.vis) v = { ...v, vis: 1, tabs: ['vis', ...v.tabs] }; if (!v.d3) v = { ...v, d3: 1, tabs: [...v.tabs, '3d'] }; if (!v.v3) v = { ...v, v3: 1, tabs: [...v.tabs, 'rtk'] }; return v; } } catch { /* first start */ }
  return { tabs: effWidth() < 768 ? UI_COMPACT : UI_TABS, hidden: false, fade: false, vis: 1, d3: 1, v3: 1 };
};

export function useMapUi() {
  const [ui, setUi] = useState(load);
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ui)); }, [ui]);
  const set = (p) => setUi((u) => ({ ...u, ...p }));
  return { ...ui, set, show: (k) => ui.tabs.includes(k) };
}

export function MapUiMenu({ t, ui, onClose }) {
  const toggle = (k) => ui.set({ tabs: ui.tabs.includes(k) ? ui.tabs.filter((x) => x !== k) : [...ui.tabs, k] });
  return (
    <div className="ui-menu mask" data-testid="map-ui-menu">
      <div className="ov-panel-head mask-keep"><b><Settings2 size={14} /> {t.uiMenuTitle}</b><MaskToggle t={t} id="mapui" /><button className="icon-btn" data-testid="map-ui-menu-close" onClick={onClose}><X size={14} /></button></div>
      <div className="ov-panel-row">
        <button className="btn btn-accent btn-sm" data-testid="map-ui-profile-compact" onClick={() => ui.set({ tabs: UI_COMPACT })}><Smartphone size={14} /> {t.uiCompact}</button>
        <button className="btn btn-dark btn-sm" data-testid="map-ui-profile-all" onClick={() => ui.set({ tabs: UI_TABS })}><LayoutGrid size={14} /> {t.uiAll}</button>
        <button className="btn btn-outline btn-sm" data-testid="map-ui-profile-none" onClick={() => ui.set({ tabs: [] })}>{t.visAllOff}</button>
      </div>
      <div className="ui-checks">
        {UI_TABS.filter((k) => !(NO_TAB[getMode()] || []).includes(k)).map((k) => (
          <label key={k}><input type="checkbox" data-testid={`map-ui-check-${k}`} checked={ui.tabs.includes(k)} onChange={() => toggle(k)} /> {t['uiTab_' + k]}</label>
        ))}
      </div>
      <WalkToggle t={t} testid="map-ui-walk-hide" />
    </div>
  );
}

export function WalkToggle({ t, testid }) {
  const on = useWalkHide();
  return (
    <label className="vs-toggle"><input type="checkbox" data-testid={testid} checked={on} onChange={() => setWalkHide(!on)} />
      <span><b>{t.walkHide}</b><br /><small className="muted">{t.walkHideD}</small></span>
    </label>
  );
}
